import IndexLayout from "../Layouts/IndexLayout";
import MainLayout from "../Layouts/MainLayout";
import PagesLayaut from '../Layouts/PagesLayaut'
import { createBrowserRouter } from "react-router-dom";
import Usuarios from '../Pages/Usuarios/Usuarios'
import Banners from "./Banners/Banners";
import Main from "./Main/Main";
import Categorias from "./Categorias/Categorias";
import PageDetail from '../Pages/PageDetail/PageDetail';
import TallerDetail from '../Pages/TallerDetail/TallerDetail';
import Tienda from "./Tienda/Tienda";
import Turnos from './Turnos/Turnos'
import Servicios from './Servicios/Servicios'
import Citas from "./Citas/Citas";
import Disponibilidad from "./Disponibilidad/Disponibilidad";
import Reportes from './Reportes/Reportes';
import Talleres from './Talleres/Talleres';
import CitasTalleresPage from './CitasTalleres/CitasTalleres';

export { default as Reportes } from './Reportes/Reportes';
export { default as Talleres } from './Talleres/Talleres';
export const router = createBrowserRouter([

    {
        path: "/",
        element: <IndexLayout />,

    },
    {
        path: "/",
        element: <PagesLayaut />,
        children: [
            {
                path: `/servicio/:idServicio/:servicio`,
                element: <PageDetail />,
            },
            {
                path: `/taller/:idTaller`,
                element: <TallerDetail />,
            }
        ]
    },
    {
        path: "/",
        element: <MainLayout />,
        children: [
            {
                path: `/dashboard`,
                element: <Main />,
            },

            {
                path: `/dashboard/usuarios`,
                element: <Usuarios />,
            },
            {
                path: `/dashboard/banners`,
                element: <Banners />,
            },

            {
                path: `/dashboard/categorias`,
                element: <Categorias />,
            },

            {
                path: `/dashboard/servicios/:idServicio?`,
                element: <Servicios />,
            },
            {
                path: `/dashboard/turnos`,
                element: <Turnos />,
            },
            {
                path: `/dashboard/citas`,
                element: <Citas />,
            },
            {
                path: `/dashboard/disponibilidad`,
                element: <Disponibilidad />,
            },

            {
                path: `/dashboard/contacto`,
                element: <Tienda />,
            },

            {
                path: `/dashboard/reportes`,
                element: <Reportes />,
            },
            {
                path: `/dashboard/talleres`,
                element: <Talleres />,
            },
            {
                path: `/dashboard/talleres/:idTaller/horarios`,
                element: <Talleres />,
            },
            {
                path: `/dashboard/citas-talleres`,
                element: <CitasTalleresPage />,
            },

        ],
    },


]);
